// extracted by mini-css-extract-plugin
export default {"section":"ItemMenuBase_section__fH3-i","section_title":"ItemMenuBase_section_title__Couqm","section_devider":"ItemMenuBase_section_devider__FabeR"};